import client from './client';

const CompanyAffiliates = {
  getAffiliates(anketId) {
    return client.get(`/ankets/${anketId}/kf_analytics/company_affiliates`);
  },
};

export default CompanyAffiliates;
